import { render, staticRenderFns } from "./CarrierInfoCard.vue?vue&type=template&id=105b6ce5&scoped=true&"
import script from "./CarrierInfoCard.vue?vue&type=script&lang=js&"
export * from "./CarrierInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b6ce5",
  null
  
)

export default component.exports